const NAMESPACE = "contact";

const KEYS = {
    nameLabel: "nameLabel",
    firstNamePlaceholder: "firstNamePlaceholder",
    lastNamePlaceholder: "lastNamePlaceholder",
    companyLabel: "companyLabel",
    companyPlaceholder: "companyPlaceholder",
    emailLabel: "emailLabel",
    emailPlaceholder: "emailPlaceholder",
    phoneLabel: "phoneLabel",
    phoneUnformattedPlaceholder: "phoneUnformattedPlaceholder"
};

const MESSAGES = {
    [KEYS.nameLabel]: {
        value: "Name",
        comment: "Label for name input fields"
    },
    [KEYS.firstNamePlaceholder]: {
        value: "First",
        comment: "Placeholder for first name input field"
    },
    [KEYS.lastNamePlaceholder]: {
        value: "Last",
        comment: "Placeholder for last name input field"
    },
    [KEYS.companyLabel]: {
        value: "Company",
        comment: "Label for company input field"
    },
    [KEYS.companyPlaceholder]: {
        value: "Company",
        comment: "Placeholder for company input field"
    },
    [KEYS.emailLabel]: {
        value: "Email",
        comment: "Label for email input field"
    },
    [KEYS.emailPlaceholder]: {
        value: "Email",
        comment: "Placeholder value for email input field"
    },
    [KEYS.phoneLabel]: {
        value: "Phone",
        comment: "Label for phone number input field"
    },
    [KEYS.phoneUnformattedPlaceholder]: {
        value: "Phone",
        comment: "Placeholder for phone number when strict phone formatting is not required"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
